import { BlockTitle } from "@blocks/Blocks";
import TemplateI from "@particles/card/templates/TemplateI/TemplateI";
import { ComponentPropsWithTitle } from "@routes/Keyword/utils/types";

type HighlightsProps = {
  /** The classname for the component styling. */
  className?: string;
  /** The articles to be displayed on highlights section. */
  highlights: ComponentPropsWithTitle;
};

/**
 * Highlights component with title that is displayed in HIGHLIGHTS section
 * https://www.figma.com/design/QCEPjsj7Sdm5KqnY3ta5tq/TEMPLATES--WEB---APP-?node-id=1-12485&t=NMzsh6SczSQjIa80-4
 */
export const Highlights = ({
  className,
  highlights,
}: HighlightsProps): React.ReactElement => {
  if (highlights.props.length === 0) return <></>;

  return (
    <div data-testid="highlights-component" className={className}>
      <BlockTitle
        text={highlights.title.toUpperCase()}
        rootClassName="mb-4 md:text-3xl"
      />

      <TemplateI cardProps={highlights.props} />
    </div>
  );
};

export default Highlights;
